<template>
    <div :id="id" element="TextComponent" class="sitebuilder-element-container"
         :style="style()"
         :dir="dir()"
         :data-tag="dataTag()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :data-editing="this.editing">
      <div :style="`transform: rotate(${this.$props.device === 'desktop' ? this.internal_config.rotation : 0}) scale(1)`">


        <!--      <div v-html="internal_config.order_mobile" style="text-align: center"></div>-->

        <span class="sitebuilder-element desktop-element" v-show="!this.editing"
              :style="'font-size: '+ internal_config.fontSize + ' !important;font-weight: '+ internal_config.weight "
              v-html="this.internal_config.content"></span>
        <span class="text-center-sb sitebuilder-element mobile-element"
              :style="'font-size: '+ internal_config.fontSizeMobile + ' !important;font-weight: '+ internal_config.weight + ';text-align: '+ internal_config.alignMobile + ' !important;'"
              v-html="mobileContent"></span>
      </div>
    </div>
</template>

<script>

	import TextData from './Model';

	export default {
		name: 'TextComponent',
		props: ['config', 'id', 'preview', 'device'],
		components: {
			TextData,
		},
		data() {
			return TextData.data();
		},
		methods: {
			dataTag() {
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
			fontSizeMobileChange() {

				let elements = document.getElementById(this.$el.id).querySelectorAll('.mobile-element p,.mobile-element span,.mobile-element h1,.mobile-element h2,.mobile-element h3,.mobile-element h4,.mobile-element h5,.mobile-element h6,.mobile-element ul,.mobile-element em,.mobile-element ol,.mobile-element li,.mobile-element big,.mobile-element small');

				for (var i in elements) {
					$(elements[i]).css({'font-size': parseInt(this.internal_config.fontSizeMobile) + 'px'});
				}
			},

			alignMobileChange() {

				let elements = document.getElementById(this.$el.id).querySelectorAll('.mobile-element p,.mobile-element span,.mobile-element h1,.mobile-element h2,.mobile-element h3,.mobile-element h4,.mobile-element h5,.mobile-element h6,.mobile-element ul,.mobile-element em,.mobile-element ol,.mobile-element li,.mobile-element big,.mobile-element small');

				for (var i in elements) {
					$(elements[i]).css({'text-align': this.internal_config.alignMobile});
				}
			},

            linkAction(event) {
			  this.$root.$emit('linkAction', event.data.link);
            },

            IsValidJSONString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            },

            setLinks() {
                let vm = this;
                setTimeout(function () {
                    let elementsLink = $(`#${vm.id} a[type][value][tel]`);

                    if (elementsLink.length === 0) {
                        return;
                    }

                    elementsLink.each(function () {
                        let elementLink = $(this);
                        let link = {
                            type: elementLink.attr('type'),
                            value: elementLink.attr('value'),
                            valueID: elementLink.attr('valueID'),
                            target: elementLink.attr('target'),
                            tel: elementLink.attr('tel'),
                            telSelectedMask: elementLink.attr('telSelectedMask'),
                            telOpenAs: elementLink.attr('telOpenAs'),
                            secondaryLink: vm.$isJson(elementLink.attr('secondaryLink')) ? JSON.parse(elementLink.attr('secondaryLink')) : false,
                        }

                        if (['email', 'download', 'builderall'].includes(elementLink.attr('type'))) {
                            if (vm.IsValidJSONString(link.value)) {
                                link.value = JSON.parse(link.value);
                            } else {
                                link.value = {
                                    name: elementLink.attr('name'),
                                    src: elementLink.attr('src')
                                };
                            }
                        }

                        elementLink.css('cursor', 'pointer');

                        elementLink.on('click', {link}, vm.linkAction);
                    });
                }, 1000);
            },

			build(config) {
				this.internal_config = config;
				this.internal_config.content = this.internal_config.content.replace(/&nbsp;/g, ' ');

				if (this.internal_config.content.indexOf('clean-text-css') !== -1) {

					if (this.internal_config.content.indexOf('line-height') !== -1) {
						this.internal_config.content = this.internal_config.content.replace(/display:block;/g, "");
						// this.internal_config.content = this.internal_config.content.replace(/line-height:/g, "display:block;line-height:");
					}

				}
				if (this.internal_config.content.indexOf('data-tag') !== -1) {

					// this.internal_config.content = this.internal_config.content.replace(/data-tag/, "style=\"display:none\" data-tag");

                    let appendScripts = true;

                    // if(typeof window.tags_script == 'undefined') {
                    //     window.tags_script = true;
                    // }else{
                    //     appendScripts = false;
                    // }

			
                    if(appendScripts) {

						setTimeout(function () {
							// $('[data-tag]').off('click');
							var s = document.createElement("script");
							s.type = "text/javascript";
							s.src = "/static/office/script.js";
							$("head").append(s);
							setTimeout(function () {
								$('.sitebuilder-element [data-tag]').css('display', 'initial');
							}, 4000);
						}, 2000);

					
					
					}


					// setTimeout(function () {
					// 	$('.sitebuilder-element [data-tag]').css('display', 'initial');
					// }, 4000);
				}


				setTimeout(() => {

					let all = document.querySelectorAll('[element="TextComponent"] span');

					for (var i = 0, max = all.length; i < max; i++) {
						all[i].style['-webkit-text-fill-color'] = all[i].style.color;
					}
					all.forEach((el) => {
						if (el.style.lineHeight != '') {
							el.classList.add('line-height-aqui');
						}
					})
				}, 2000);
			},

			style() {

				let width = this.internal_config.width;
				let left = this.internal_config.left;

				if(navigator.userAgent.indexOf("Firefox") > 0){
					width = (parseInt(width) + 10) + 'px';
					left = (parseInt(left) -5) + 'px';
                }
				return `width: ${width};
                left:  ${left};
                padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-bottom: ${this.internal_config.paddingBottom};
								top: ${this.internal_config.top};`;
			},
			dir(){
				if (
					typeof langUser != 'undefined' && (
					langUser === 'he' ||
					langUser === 'ja' ||
					langUser === 'ar')
				) {
					return 'rtl';
				} else return false;
			},
		},
		mounted() {
			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.fontSizeMobileChange();
			this.alignMobileChange();

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
		},
		computed: {
			// internal_config.alignMobile replace editor alignments
			mobileContent: function() {
				return this.internal_config.content.replace(/text-align: left|text-align: right|text-align: center|text-align: justify/g, "text-align: inherit");
			}
		},
        watch: {
            'internal_config.content': function (val) {
                if(val) {
                    this.setLinks();
                }
            }
        }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @media (max-width: 980px) {
        .desktop-element {
            display: none !important;
        }

        .mobile-element {
            display: block !important;
        }
    }

    @media (min-width: 981px) {
        .desktop-element {
            display: block !important;
        }

        .mobile-element {
            display: none !important;
        }
    }

    .auto-height {
        height: auto !important;
    }

    .text-center-sb {
        text-align: center;
    }

</style>

